<template>
<v-menu offset-y width="400">
    <template v-slot:activator="{ on, attrs }">
        <v-btn dark icon v-bind="attrs" v-on="on" small>
            <v-icon size="16">mdi-dots-vertical</v-icon>
        </v-btn>
    </template>
    <v-list dense>
        <div v-for="(item, index) in items" :key="index">
            <v-divider v-if="index > 0"/>
            <v-list-item :to="item.route">
                <v-list-item-icon>
                    <v-icon>{{item.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action></v-list-item-action>
            </v-list-item>
        </div>
    </v-list>
</v-menu>
</template>

<script>
export default {
    name: 'DialogScrollable',
    components: {},
    computed: {},
    data() {
        return {
            items: [{
                    title: 'Logged In As',
                    route: "/logins",
                    icon: "mdi-shield-account"
                },
                {
                    title: 'About',
                    route: "/about",
                    icon: "mdi-information"
                },
            ],
        }
    },
    methods: {}
}
</script>

<style scoped lang="scss">
</style>
